<template>
  <BaseSection>
    <template #header>
      <BaseTitle
        tag="h1"
        size="l"
        is-medium
        data-animation="fadeIn"
        data-animation-delay="100"
        text="В классическом представлении EVP&nbsp;состоит из&nbsp;следующих компонентов"
      />
    </template>
    <template #content>
      <BaseFeatures :items="features" :delay="300" is-clean is-double />
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseFeatures from '@/components/BaseFeatures.vue';

export default {
  name: 'EvpPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseFeatures,
  },
  staticData: () => ({
    features: [
      {
        image: 'financial',
        title: 'Финансовое вознаграждение',
        list: [
          { text: 'заработная плата' },
          { text: 'программа повышения заработной платы' },
          { text: 'бонусы, премии, льготы' },
          { text: 'долевое участие' },
        ],
      },
      {
        image: 'motivation',
        title: 'Нематериальная мотивация',
        list: [
          { text: 'медицинское страхование' },
          { text: 'возможность заниматься спортом, языками и.т.д. за&nbsp;счет&nbsp;компании' },
          { text: 'оплачиваемые отпуска' },
        ],
      },
      {
        image: 'career',
        title: 'Карьерный рост',
        list: [
          { text: 'возможность вертикального роста' },
          { text: 'обучение за счет компании (внутренние и&nbsp;внешние тематические курсы)' },
          { text: 'возможность смены локации с&nbsp;повышением' },
        ],
      },
      {
        image: 'working',
        title: 'Рабочая обстановка',
        list: [
          { text: 'нефиксированный рабочий график' },
          { text: 'скрепление команды' },
          { text: 'баланс между работой и&nbsp;личной жизнью' },
          { text: 'свой кабинет' },
        ],
      },
      {
        image: 'culture',
        title: 'Корпоративная культура',
        list: [
          { text: 'наличие сформулированной миссии, ценностей, целей' },
          { text: 'положительное общение' },
          { text: 'поддержка' },
          { text: 'соц. ответственность и&nbsp;уважение в&nbsp;коллективе' },
        ],
      },
    ],
  }),
};
</script>
